import LayoutContext from '../../context/Layout';
import { useContext } from 'react';

const useUser = () => {
  const [currentIdentityQuery] = useContext(LayoutContext);
  return currentIdentityQuery?.data?.currentIdentity;
};

export default useUser;
